import "./coinCard.scss";
import React, { useState, useEffect } from "react";

import { useSelector } from "react-redux";

// coin image import
import coinImg from "../../assets/images/icons/coinImg.png";
import emamiCoinImg from "../../assets/images/icons/emamiImg.png";
import chart from "../../assets/icons/icones moj-10.svg";
import whiteChart from "../../assets/icons/icones moj-10-white.svg";
import downArrow from "../../assets/icons/icones moj-16.svg";
import upArrow from "../../assets/icons/icones moj-17.svg";
import ChartModal from "../ChartModal";

const CoinCard = ({ coin }) => {
  const { REACT_APP_URL } = process.env;

  // states
  const [modalOpen, setModalOpen] = useState(false);
  const [buyPrices, setBuyPrices] = useState([]);
  const [sellPrices, setSellPrices] = useState([]);

  // store
  const darkThemeFromStore = useSelector(
    (state) =>
      // console.log(state);
      state.Reducer.darkTheme
  );

  useEffect(() => {
    fetch(`${REACT_APP_URL}/api/coin-archive`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        coinId: coin?.CoinId,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // Extract buyPrices and sellPrices into separate arrays
        setBuyPrices(data.data.map((item) => parseFloat(item.buyPrice)));
        setSellPrices(data.data.map((item) => parseFloat(item.sellPrice)));
      })
      .catch((err) => console.log(err));
  }, []);

  // handlers
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <div
      className={`coin-card-container ${
        darkThemeFromStore ? "dark-back2" : ""
      }`}
    >
      <div className="coin-title">
        <div className="coin-name">
          <div
            className={`coin-img ${
              coin?.CoinId === 5
                ? "nim"
                : coin?.CoinId === 7
                ? "rob"
                : coin?.CoinId === 9
                ? "yek"
                : ""
            }`}
          >
            <img
              src={coin?.CoinId === 3 ? emamiCoinImg : coinImg}
              alt={coin?.Coin?.symbol}
            />
          </div>
          <div>
            <h3>{coin?.Coin?.name}</h3>
          </div>
        </div>
        <div className="chart">
          <img
            src={darkThemeFromStore ? whiteChart : chart}
            alt={coin?.Coin?.symbol}
            onClick={openModal}
          />
          <ChartModal
            isOpen={modalOpen}
            onClose={closeModal}
            buyPrices={buyPrices}
            sellPrices={sellPrices}
          />
        </div>
      </div>
      <div className="price">
        <div>
          <h4>فروش:</h4>{" "}
          <span className="font-hel">
            {coin?.sellPrice.toLocaleString()}
            <img
              src={coin?.sellPrice > coin?.pSellPrice ? upArrow : downArrow}
              alt=""
            />
          </span>
        </div>
        <div>
          <h4>خرید:</h4>{" "}
          <span className="font-hel">
            {coin?.buyPrice.toLocaleString()}
            <img
              src={coin?.sellPrice > coin?.pSellPrice ? upArrow : downArrow}
              alt=""
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default CoinCard;
